/*
Global inline scripts for inclusion in Layout. Primarily analytics stuff.

Everything here has been moved to gatsby-ssr.js

*/
import React from 'react'

const GlobalScripts = () => {
  return <></>
}
export default GlobalScripts
